import { cva, type VariantProps } from 'class-variance-authority'
import { Loader2 } from 'lucide-react'
import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Spinner — loading indicator. Pencil LFw7c.
 * Honours `prefers-reduced-motion` via global CSS rule.
 */
export const spinnerVariants = cva('animate-spin text-ia-text-tertiary', {
  variants: {
    size: { xs: 'h-3 w-3', sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-6 w-6', xl: 'h-8 w-8' },
  },
  defaultVariants: { size: 'md' },
})

export interface SpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {
  label?: string
}

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size, label = 'Loading', ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-label={label}
      className={cn('inline-flex', className)}
      {...props}
    >
      <Loader2 className={cn(spinnerVariants({ size }))} strokeWidth={1.75} />
      <span className="sr-only">{label}</span>
    </div>
  ),
)
Spinner.displayName = 'Spinner'
